<template>
  <div class="profile">
    <h1>This is the Profile Page</h1>
  </div>
</template>

<script>
export default {
  name: 'profile'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>


// WEBPACK FOOTER //
// profile.vue?18bd2858